import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "../i18n/strings";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param === "es" || param === "en") return param;
    return localStorage.getItem("omnia_lang") || "es";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("omnia_lang", l);
    setLangState(l);
  };

  const t = (key) => {
    const parts = key.split(".");
    let v = STRINGS[lang] || STRINGS.es;
    for (const p of parts) v = v?.[p];
    return v ?? key;
  };

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
